var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React, { useContext, useEffect, useState } from "react";
import { Box, Card, Heading, Paragraph, ResponsiveContext } from "grommet";
import styled from "styled-components";
import { isMobileTabletResponsive } from "../../utils/utils";
import { makeValidationSchema } from "./makeValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { SquareCheckBox } from "../Checkboxes/SquareCheckBox";
import { PopupWithButton } from "../Popups/PopupWithButton";
import { DefaultButton } from "../Buttons/DefaultButton";
import { TextInput } from "../Inputs/TextInput";
var CustomHeading = styled(Heading)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n"]))
);
var CustomParagraph = styled(Paragraph)(
  _templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  max-width: 448px;\n"]))
);
export var Subscribe = function Subscribe(_ref) {
  var subscribeStatus = _ref.subscribeStatus,
    setNewSubscribe = _ref.setNewSubscribe,
    setSubscribeStatus = _ref.setSubscribeStatus;
  var validateForm = makeValidationSchema();

  var _useForm = useForm({
      resolver: yupResolver(validateForm),
      shouldFocusError: false,
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    errors = _useForm.formState.errors,
    clearErrors = _useForm.clearErrors,
    setValue = _useForm.setValue;

  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);

  var _useState = useState(false),
    isCheckedPersonal = _useState[0],
    setIsCheckedPersonal = _useState[1];

  useEffect(function () {
    return function () {
      setSubscribeStatus(false);
    };
  }, []);

  var personalDataToggleHandler = function personalDataToggleHandler(event) {
    var checked = event.target.checked;
    setIsCheckedPersonal(checked);
  };
  /* const handleSetNewSubscribe = (event) => {
    event.preventDefault();
    setNewSubscribe({ email });
  }; */

  var onSubmit = function onSubmit(_ref2) {
    var email = _ref2.email;
    setNewSubscribe({
      email: email,
    });
  };

  return /*#__PURE__*/ React.createElement(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
    },
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Card,
        {
          flex: true,
          margin: {
            bottom: "48px",
          },
          pad: {
            horizontal: "large",
            vertical: "38px",
          },
          background: "light-1",
          direction: size !== "desktop1900" ? "column" : "row",
          gap: isMobileWidth ? "large" : "medium",
          justify: "between", // align={size !== `desktop1900` ? `start` : `center`}
          // elevation={`none`}
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            direction: "column",
          },
          /*#__PURE__*/ React.createElement(
            CustomHeading,
            {
              size: "26px",
              margin: {
                bottom: "8px",
              },
            },
            "\u041F\u043E\u0434\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u043D\u0430\u0448\u0438 \u043D\u043E\u0432\u043E\u0441\u0442\u0438"
          ),
          /*#__PURE__*/ React.createElement(
            CustomParagraph,
            {
              size: "small",
            },
            "\u0421\u043B\u0435\u0434\u0438\u0442\u0435 \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u043C\u0438 \u043D\u043E\u0432\u043E\u0441\u0442\u044F\u043C\u0438 \u0432 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u043C \u0442\u0440\u0438\u0430\u0442\u043B\u043E\u043D\u0435! \u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u043D\u044B\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0441\u0435\u0431\u0435 \u043D\u0430 \u043F\u043E\u0447\u0442\u0443!"
          ),
          /*#__PURE__*/ React.createElement(DefaultButton, {
            type: "submit",
            caption: "Подписаться на рассылку",
            width: "406px",
            marginTop: "2rem",
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            direction: "column",
            height: isMobileWidth ? "" : "130px",
          },
          /*#__PURE__*/ React.createElement(Controller, {
            name: "email",
            control: control,
            render: function render(_ref3) {
              var _errors$email;

              var field = _ref3.field;
              return /*#__PURE__*/ React.createElement(
                TextInput,
                _extends(
                  {
                    error: (_errors$email = errors.email) == null ? void 0 : _errors$email.message,
                    handleFocus: function handleFocus() {
                      return clearErrors("email");
                    },
                    name: "email",
                    id: "subscribe-email",
                    handleChange: function handleChange(e) {
                      return setValue(e.target.value);
                    },
                    label: "\u0412\u0430\u0448 e-mail",
                  },
                  field
                )
              );
            },
          }),
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(SquareCheckBox, {
              onChange: personalDataToggleHandler,
              label: "Я согласен на обработку персональных данных",
              checked: isCheckedPersonal,
            })
          )
        ),
        subscribeStatus
          ? /*#__PURE__*/ React.createElement(PopupWithButton, {
              subtext: "Подписка оформлена!",
              closePopup: function closePopup() {
                return setSubscribeStatus(false);
              },
              button:
                "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u043D\u043E\u0432\u043E\u0441\u0442\u044F\u043C",
            })
          : null
      );
    })
  );
};
